export default __webpack_public_path__ + "static/TrustAlice Illustrations--04-8672661c524e55a8a3f5d7e7d4294d12.svg";